import React from 'react';
import { Dropdown as AntdDropdown } from 'antd';
import type { DropdownProps as AntdDropdownProps } from 'antd';

export interface DropdownPropsType extends AntdDropdownProps {
    isList?: boolean;
}

const Dropdown: React.FC<DropdownPropsType> = (props) => {
    const {
        children,
        ...rest
    } = props;

    return (
        <AntdDropdown
            {...rest}
        >
            {children}
        </AntdDropdown>
    );
};

export default Dropdown;